// Copyright (c) Bentley Systems
import { Badge, Tooltip } from "@itwin/itwinui-react";

/**
 * An on-prem client's installed version, or "v N/A" with an explanation when none was reported.
 * `iTwinScoped` is for views that only know about runs in the current iTwin.
 */
const OnPremVersionBadge = ({ version, iTwinScoped = false }: { version?: string; iTwinScoped?: boolean }) =>
  version ? (
    <Tooltip content="Installed version of the on-prem client, as reported with its most recent run result.">
      <Badge backgroundColor="positive">{`v${version}`}</Badge>
    </Tooltip>
  ) : (
    <Tooltip
      content={`Version not available: the on-prem client reports its version together with run results, so it is unknown until the client returns one${iTwinScoped ? " in this iTwin" : ""}. Older on-prem client releases do not report it at all.`}
    >
      <Badge backgroundColor="hollow">v N/A</Badge>
    </Tooltip>
  );

export default OnPremVersionBadge;
